export function formatUpdatedAtLabel(isoDateTime: string | null | undefined): string {
  if (!isoDateTime) return 'Now';
  const d = new Date(isoDateTime);
  if (Number.isNaN(d.getTime())) return 'Now';

  const now = new Date();
  const deltaMs = Math.abs(now.getTime() - d.getTime());
  if (deltaMs < 60 * 60 * 1000) return 'Now';

  return d.toLocaleString(undefined, { month: 'short', day: 'numeric' });
}
